import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Typography, CircularProgress, Button, Menu, MenuItem } from '@mui/material';
import { debounce, isArray } from "lodash";
import {
  getRevenueDownLoad,
  getRevenueMatrix,
  getRevenueReport,
} from 'redux/actions/ReportsAction';
import { fetchCompanyList, fetchParentCompanys } from "redux/actions/companyAction";
import { getServiceCity } from "redux/actions/UserServiceCity";
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import CommonButton from 'components/commonButton/CommonButton';
import CommonTable from 'components/commonTable/CommonTable';
import Loader from 'components/loader/Loader';
import CommonDateRangePicker from "components/commonDateRangePicker/CommonDateRangePicker";
import BillingFilter from 'pages/operation/billing/billingFlow/billingFilter/BillingFilter';
import CommonFilter from 'components/commonFilter/CommonFilter';
import { getDateFormat, handlePermissions } from 'utils/utils';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import CommonReportCard from 'pages/reports/CommonReportCard';
import {
  revenueFilterData,
  breadcrumbPaths,
  revenueOptionsBar,
  reportFilterOptions
} from './DummyDataReport';
import revenueImg from 'assets/images/revenueImg.svg';
import { requestBookingReportApi } from 'services/BookingReportService';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";

function Report() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [status, setStatus] = useState([]);
  const [location, setLocation] = useState([]);
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
  const [dateFrom, setDateFrom] = useState(
    state?.fromTab
      ? state?.dateFrom
      : getDateFormat(thirtyDaysAgo, 'reservationDateFormat')
  );
  const [dateTo, setDateTo] = useState(
    state?.fromTab
      ? state?.dateTo
      : getDateFormat(new Date(), 'reservationDateFormat')
  );
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedParentCompany, setSelectedParentCompany] = useState('');
  const [selectedAllCompany, setSelectedAllCompany] = useState('');
  const [isRequestingReport, setIsRequestingReport] = useState(false);

  const revenueDatas = useSelector(
    (state) => state?.getRevenueList?.revenueList?.data
  );
  const revenueMatrix =
    useSelector((state) => state?.getRevenueMatrix?.revenueMatrix?.data) || {};
  const revenueMatrixLoader = useSelector(
    (state) => state?.getRevenueMatrix?.loading
  );
  const totalCount = revenueMatrix?.datasets?.[0]?.total;

  const profileData = JSON?.parse(localStorage.getItem('user'));
  const role = localStorage.getItem('role');
  const locationData = profileData?.Company?.ServiceCity?.id;
  const [billingFilter, setBillingFilter] = useState({
    companyName: {},
    parentCompanyName: {},
    city: {},
  });

  let revenueReportPayload = {
    page: page,
    pageSize: rowsPerPage,
    status: status,
    location: location,
    dateTo: dateTo,
    dateFrom: dateFrom,
    city: billingFilter?.city?.value,
    parentCompany: billingFilter?.parentCompanyName?.value,
    companyId: billingFilter?.companyName?.value,
  };

  useEffect(() => {
    dispatch(getRevenueMatrix(revenueReportPayload));
    dispatch(getRevenueReport(revenueReportPayload));
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getRevenueReport({ ...revenueReportPayload, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getRevenueReport({
        ...revenueReportPayload,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  const onSelectDateRange = (newValue) => {
    setPage(0);
    if (newValue === null || newValue === 0) {
      setDateFrom('');
      setDateTo('');
      revenueReportPayload = {
        ...revenueReportPayload,
        dateFrom: '',
        dateTo: '',
        page: 0,
      };
    } else {
      setDateFrom(getDateFormat(newValue[0], 'reservationDateFormat'));
      setDateTo(getDateFormat(newValue[1], 'reservationDateFormat'));
      revenueReportPayload = {
        ...revenueReportPayload,
        dateFrom: getDateFormat(newValue[0], 'reservationDateFormat'),
        dateTo: getDateFormat(newValue[1], 'reservationDateFormat'),
        page: 0,
      };
    }
    dispatch(getRevenueReport(revenueReportPayload));
    dispatch(getRevenueMatrix(revenueReportPayload));
  };

  //Filter Reset
  const onFilterChange = (val) => {
    const defaultStatus = ['success', 'Pending', 'failed', 'refund'];
    const defaultLocation = ['rental', 'airport', 'outStation'];
    const filterStatus = val.filter((status) => {
      return defaultStatus.includes(status);
    });

    const filterLocations = val.filter((DutyType) => {
      return defaultLocation.includes(DutyType);
    });

    setLocation(filterLocations);
    setStatus(filterStatus);
    setPage(0);

    const revenueFilter = {
      ...revenueReportPayload,
      status: filterStatus?.toString(),
      location: filterLocations?.toString(),
      page: 0,
    };
    dispatch(getRevenueReport(revenueFilter));
    dispatch(getRevenueMatrix(revenueFilter));
  };

  // ---Reset Filter---
  const onRestFilter = () => {
    dispatch(
      getRevenueReport({
        ...revenueReportPayload,
        status: '',
        location: '',
        page: 0,
      })
    );
    dispatch(
      getRevenueMatrix({
        ...revenueReportPayload,
        status: '',
        location: '',
        page: 0,
      })
    );
    setStatus([]);
    setLocation([]);
    setPage(0);
  };

  // New Filter Added

  let filterData = {
    search: "",
  };
  useEffect(() => {
    dispatch(
      fetchCompanyList(filterData, {
        searchType: "globalSearch",
        loader: "backDropLoader",
      })
    );
    dispatch(
      fetchParentCompanys(filterData, {
        searchType: "globalSearch",
        loader: "backDropLoader",
      })
    );
    dispatch(getServiceCity());
  }, []);

  const companyTableData = useSelector(
    (state) => state?.userCompany?.companyList?.body
  );
  const locationOptions = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );

  const parentCompanyList = useSelector(
    (state) => state?.parentCompanyList?.parentCompanyList?.body
  );

  const parentCompanyListOption =
    parentCompanyList?.length > 0 &&
    parentCompanyList?.map((val) => {
      return { value: val?.id, label: val.name };
    });

  const companyOption =
    companyTableData?.length > 0 &&
    companyTableData?.map((val) => {
      return { value: val?.id, label: val.name };
    });

  const cityOption =
    locationOptions?.length > 0 &&
    locationOptions?.map((val) => {
      return { value: val?.id, label: val.name };
    });

    const handleFilter = (name, newValue) => {
      setBillingFilter((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));
  
      if (name === "companyName") {
        const bookingReportPayloads = {
          ...revenueReportPayload,
          companyId: newValue?.value,
          page: 0,
        };
        dispatch(getRevenueReport(bookingReportPayloads));
        dispatch(getRevenueMatrix(bookingReportPayloads));
      } else if (name === "city") {
        const bookingReportPayloads = {
          ...revenueReportPayload,
          city: newValue?.value,
          page: 0,
        };
        dispatch(getRevenueReport(bookingReportPayloads));
        dispatch(getRevenueMatrix(bookingReportPayloads));
      }else if (name === "parentCompanyName") {
        const bookingReportPayloads = {
          ...revenueReportPayload,
          parentCompany: newValue?.value,
          page: 0,
        };
        dispatch(getRevenueReport(bookingReportPayloads));
        dispatch(getRevenueMatrix(bookingReportPayloads));
      }
    };

  //company Auto suggestion
  const onHandleAutoSuggestion = debounce((event, value, fieldName) => {
    if (event?.type === "change") {
      if (fieldName === "companyName" && value) {
        dispatch(
          fetchCompanyList(
            { ...filterData, search: value },
            { searchType: "globalSearch", loader: "backDropLoader" }
          )
        );
      } else {
        dispatch(
          fetchCompanyList(filterData, {
            searchType: "globalSearch",
            loader: "backDropLoader",
          })
        );
      }

      if(fieldName === "parentCompanyName" && value) {
        dispatch(
          fetchParentCompanys(
            { ...filterData, search: value },
            { searchType: "globalSearch", loader: "backDropLoader" }
          )
        );
      } else {
        dispatch(
          fetchParentCompanys(filterData, {
            searchType: "globalSearch",
            loader: "backDropLoader",
          })
        );
      }
    }
  }, 500);
  //---Company select and Parent Company

  const handleCityChange = (e) => {
    setPage(0);
    setSelectedCity(role !== 'adminCompany' ? locationData : e.target.value);
    const revenueReportPayloads = {
      ...revenueReportPayload,
      city: role !== 'adminCompany' ? locationData : e.target.value,
      page: 0,
    };
    dispatch(getRevenueReport(revenueReportPayloads));
    dispatch(getRevenueMatrix(revenueReportPayloads));
  };

  const handleParentCompanyChange = (e) => {
    setSelectedParentCompany(e.target.value);
    const revenueReportPayloads = {
      ...revenueReportPayload,
      parentCompany: e.target.value,
      page: 0,
    };
    dispatch(getRevenueReport(revenueReportPayloads));
    dispatch(getRevenueMatrix(revenueReportPayloads));
  };

  const handleAllCompanyChange = (e) => {
    setSelectedAllCompany(e.target.value);
    const revenueReportPayloads = {
      ...revenueReportPayload,
      companyId: e.target.value,
      page: 0,
    };
    dispatch(getRevenueReport(revenueReportPayloads));
    dispatch(getRevenueMatrix(revenueReportPayloads));
  };

  const onClick = () => {
    const reservationPayload = {
      ...revenueReportPayload,
      export: true,
    };
    dispatch(getRevenueDownLoad(reservationPayload));
  };

  //roles and permissions
  const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions
  );
  const reportBookingRoleEnum = roleAndPermissionEnum.reports;

  const accessForall = handlePermissions(
    roleAndPermissions,
    reportBookingRoleEnum.moduleKey,
    {
      defaultAllAccess: reportBookingRoleEnum.all,
      customAccess: reportBookingRoleEnum.add,
    }
  );

  const accessForOnlyView = handlePermissions(
    roleAndPermissions,
    reportBookingRoleEnum.moduleKey,
    { customAccess: reportBookingRoleEnum.view }
  );

  const accessForRevenueDownload = handlePermissions(
    roleAndPermissions,
    reportBookingRoleEnum.moduleKey,
    { customAccess: reportBookingRoleEnum?.subModules?.revenue?.download }
  );

   const onRequestReport = async (format) => {
      setIsRequestingReport(true);
      setIsRequestingReport(false);
    try {
      const payload = {
        startDate: dateFrom,
        endDate: dateTo,
        reportType: "B2B_TRIP_REVENUE_REPORT",
        reportFormate: format,
        filters: {
          location: revenueReportPayload?.city,
          type: revenueReportPayload?.location && isArray(revenueReportPayload?.location) ? revenueReportPayload?.location.join(',') : '',
          companyId: revenueReportPayload?.companyId,
          parentCompany: revenueReportPayload?.parentCompany,
          status: revenueReportPayload?.status && isArray(revenueReportPayload?.status) ? revenueReportPayload?.status.join(',') : ''
        }
      };
      const response = await requestBookingReportApi(payload);
      if (response.success) {
        toast.success("Report request submitted successfully");
        navigate("/report-generate");
      } else {
        toast.error(response?.message || "Failed to request report");
      }
    } catch (error) {
      toast.error("Error requesting report");
    }
     finally {
      setIsRequestingReport(false);
    }
  };
  
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelectFormat = (format) => {
    onRequestReport(format);
    handleClose();
  };

  return (
    <Box>
      <Box className="mtb30">
        <CommonBreadCrumb paths={breadcrumbPaths} />

        <Grid container
        >
          <Grid
            item
            container
            gap={2}
            lg={7}
            md={12}
            xs={12}
            flexWrap={{ xs: "wrap", sm: "wrap", md: "nowrap", lg: "nowrap" }}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            className=""
          >
            {reportFilterOptions(cityOption, parentCompanyListOption, companyOption) &&
              reportFilterOptions(cityOption, parentCompanyListOption, companyOption)?.map(
                (formData, index) => (
                  <Grid
                  item
                  lg={5}
                  md={12}
                  xs={12}
                  key={index}
                  className="misAutoComplete"
                  >
                    <BillingFilter
                      billingFilterValue={billingFilter}
                      setBillingFilter={setBillingFilter}
                      handleFilter={handleFilter}
                      formData={formData}
                      onHandleAutoSuggestion={onHandleAutoSuggestion}
                    />
                  </Grid>
                )
              )}
          </Grid>

          <Grid
            container
            item
            lg={5}
            sx={{justifyContent:{lg:'flex-end',md:'flex-start',sm:'flex-start',xs:'flex-start'},
                marginTop:{lg:'10px',md:'0px',sm:'0px',xs:'0px'}
          }}
          >
            <Grid item className="justifyEnd" style={{ marginTop: "24px"}}>
              <CommonDateRangePicker
                onSelectDateRange={onSelectDateRange}
                dateFrom={dateFrom}
                dateTo={dateTo}
              />
              <CommonFilter
                defaultStatus={status}
                filterdata={revenueFilterData}
                onFilterChange={onFilterChange}
                onRestFilter={onRestFilter}
                defaultLocation={location}
              />
            </Grid>
          </Grid>

        </Grid>
      </Box>
      {revenueMatrixLoader ? (
        <Loader />
      ) : (
        <CommonReportCard
          barChartData={revenueMatrix}
          loader={revenueMatrixLoader}
          count={totalCount}
          image={revenueImg}
          option={revenueOptionsBar}
          title={'Total Revenue'}
          barName={'revenue'}
        />
      )}
      <Box className="justifyBetween pb10">
        <Typography variant="body1" className="colorBlack">
          Revenue Reports
        </Typography>
        {accessForRevenueDownload && (
         <div style={{ display: "flex", gap: "20px" }}>
         <Button
           onClick={handleClick}
           disabled={isRequestingReport}
           sx={{
             backgroundColor: '#1976d2',
             borderRadius: '8px',
             color: '#fff',
             textTransform: 'none',
             paddingX: 2,
             paddingY: 1,
             '&:hover': {
               backgroundColor: '#1565c0',
             },
             '&.Mui-disabled': {
               backgroundColor: '#9e9e9e',
               color: '#fff',
             },
           }}
         >
           {isRequestingReport ? (
             <CircularProgress
               size={20}
               sx={{ color: "#fff" }}
             />
           ) : (
             "Request Report"
           )}
         </Button>
         <Menu
           anchorEl={anchorEl}
           open={open}
           onClose={handleClose}
           PaperProps={{
             sx: { width: anchorEl ? anchorEl.offsetWidth : "auto" }, // match button width
           }}
         >
           <MenuItem onClick={() => handleSelectFormat("csv")} sx={{ width: "100%",  fontSize: "14px" }}>
             Excel/CSV
           </MenuItem>
           <MenuItem onClick={() => handleSelectFormat("pdf")} sx={{ width: "100%",  fontSize: "14px" }}>
             PDF
           </MenuItem>
         </Menu>
         <CommonButton
           name="Send Report to mail"
           btnClass="btnSm btnYellow"
           onClick={onClick}
         />
        </div>
        )}
      </Box>
      <CommonTable
        data={revenueDatas}
        page={page}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Box>
  );
}

export default Report;
